<template>
  <div class="main-container" :class="colorMode === 'dark' ? 'dark-block' : ''">
    <h2>Accelerating deal origination for Africa-focused Investors</h2>
    <p><router-link to="/about/deals">Asoko Deal Platform</router-link> is an exciting extension to the Asoko platform built around one core objective: connecting Investors with pre-qualified African businesses that are actively seeking funding. Asoko supports Investors’ deal-flow through the delivery of digital data and physical deal rooms.</p>
    <p>Asoko’s most recent deal room initiative is in partnership with the UK Department for International Trade, facilitating investment opportunities UK Investors and African corporates</p>
    <div class="action-wrap">
      <a @click="openSolutions" class="cta-button" :class="colorMode === 'light' ? 'medium-button' : ''">Read More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'investor-deal-origination-conversion',
  props: {
    colorMode: {
      type: String,
    },
  },
  methods: {
    openSolutions() {
      this.$ga.event({
        eventCategory: 'Click',
        eventAction: 'Conversion',
        eventLabel: 'Investor Deal Origination Block',
      })
      this.$gtag.event('Conversion', {
        'event_category': 'Click',
        'event_label': 'Investor Deal Origination Block',
      })
      this.$router.push('/about/deals')
    },
  },
}
</script>
